import { useState } from 'react';
import { FaQuoteRight, FaStar, FaWhatsapp, FaFacebook } from 'react-icons/fa';
import ScrollableContainer from './ScrollableContainer';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

export interface ReviewItem {
  id: string;
  customerName: string;
  city: string;
  service: string;
  content: string;
  rating: number;
  platform?: 'whatsapp' | 'facebook';
}

interface ReviewsProps {
  title?: string;
  reviews: ReviewItem[];
}
const Reviews = forwardRef<HTMLElement, ReviewsProps>(({ reviews }, ref) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section ref={ref} id="reviews" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12">{t('common.feedback')}</h2>
        
        <ScrollableContainer className="h-full p-8 md:px-0">
          <div className="flex md:flex-1 flex-nowrap gap-6">
            {reviews.map((review, index) => (
              <div 
                key={review.id} 
                className={`relative bg-white rounded-lg shadow-md p-6 min-w-[300px] ${
                  index === activeIndex ? 'border-2 border-purple-500 border-dashed' : 'border border-gray-200'
                }`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="absolute top-6 text-primary-blue">
                  <FaQuoteRight size={24} />
                </div>
                
                <p className="pt-12 text-gray-700 mb-6 min-h-[100px]">{review.content}</p>
                
                <div className="flex justify-between items-end">
                  <div>
                    <p className="font-semibold text-gray-900">{review.customerName}</p>
                    <p className="text-sm text-gray-600">{review.city}</p>
                    <p className="text-sm text-gray-600">{review.service}</p>
                  </div>
                  
                  <div className="flex flex-col items-end gap-2">
                    <div className="flex items-center">
                      <div className="flex text-yellow-400 mr-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar 
                            key={i} 
                            className={i < review.rating ? "text-yellow-400" : "text-gray-300"} 
                            size={16}
                          />
                        ))}
                      </div>
                      <span className="text-gray-600 text-sm">{review.rating}/5</span>
                    </div>
                    {review.platform && (
                      <div className="text-gray-500">
                        {review.platform === 'whatsapp' ? (
                          <FaWhatsapp size={20} className="text-green-500" />
                        ) : review.platform === 'facebook' ? (
                          <FaFacebook size={20} className="text-blue-600" />
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollableContainer>
      </div>
    </section>
  );
});

export default Reviews; 